import moment from "moment";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader } from "../Common/Loader";
import Pagination from "../Common/Pagination";
import { acceptDeposit, getDepositList, rejectDeposit } from "../service/service";

const PAGE_SIZE = 10;

const PendingDepositsCard = ({ onDepositUpdated }) => {
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [depositList, setDepositList] = useState([]);
  const [page, setPage] = useState(1);

  useEffect(() => {
    handleGetDeposits();
  }, []);

  const handleGetDeposits = () => {
    getDepositList("PENDING").then((res) => {
      setDepositList(res.data?.status === false ? [] : res.data?.data || []);
    }).catch((err) => {
      alert(err?.response?.data?.message || "something went wrong ");
    });
  };

  const handleAction = (item, action) => {
    const verb = action === "APPROVE" ? "Approve" : "Reject";
    if (!window.confirm(`${verb} ₹${item?.amount} deposit from ${item?.user_id__first_name || "user"} (${item?.user_id__phone_number || "NA"})?`)) {
      return;
    }
    setLoader(true);
    const request = action === "APPROVE" ? acceptDeposit : rejectDeposit;
    request({ deposit_id: item?.id }).then((res) => {
      setLoader(false);
      if (res.data?.status === false) {
        alert(res.data?.message || "something went wrong ");
      }
      handleGetDeposits();
      if (action === "APPROVE" && onDepositUpdated) {
        onDepositUpdated();
      }
    }).catch((err) => {
      setLoader(false);
      alert(err?.response?.data?.message || "something went wrong ");
    });
  };

  const totalAmount = depositList.reduce((sum, item) => sum + (parseFloat(item?.amount) || 0), 0);
  const totalPages = Math.ceil(depositList.length / PAGE_SIZE);
  const pagedList = depositList.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

  return (
    <>
      {loader ? <Loader /> : null}
      <div className="card mb-3">
        <div className="card-header d-flex justify-content-between align-items-center">
          <span><i className="fa fa-clock-o"></i> <b>Pending Deposit Requests{depositList.length > 0 ? ` (${depositList.length}, Total: ₹${totalAmount})` : ""}</b></span>
          <div className="d-flex align-items-center" style={{ gap: "8px" }}>
            <button className="btn btn-secondary btn-sm" onClick={handleGetDeposits}>Refresh</button>
            <button className="btn btn-danger btn-sm" onClick={() => navigate("/deposit-requests")}>View All</button>
          </div>
        </div>
        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-bordered" width="100%">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Name</th>
                  <th>Mobile</th>
                  <th>Amount</th>
                  <th>Transaction ID</th>
                  <th>Date</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {pagedList.length === 0 ? (
                  <tr><td colSpan="7" className="text-center">No pending deposit requests</td></tr>
                ) : pagedList.map((item) => (
                  <tr key={item?.id}>
                    <td>{item?.id}</td>
                    <td>
                      <span className="link" style={{ color: "#0d6efd", cursor: "pointer", textDecoration: "underline" }} onClick={() => navigate("/user-details", { state: { id: item?.user_id } })}>
                        {item?.user_id__first_name || "NA"}
                      </span>
                      {item?.user_id__phone_number && (
                        <a href={`https://wa.me/91${item?.user_id__phone_number}`} target="_blank" rel="noreferrer" style={{ marginLeft: "6px", color: "#25D366" }}>
                          <i className="fa fa-whatsapp" style={{ fontSize: "16px" }}></i>
                        </a>
                      )}
                    </td>
                    <td>{item?.user_id__phone_number || "NA"}</td>
                    <td>₹{item?.amount}</td>
                    <td style={{ wordBreak: "break-all" }}>{item?.transaction_id || "NA"}</td>
                    <td>{moment(item?.created_at).format("DD-MM-YYYY, h:mm a")}</td>
                    <td>
                      <div className="d-flex" style={{ gap: "6px" }}>
                        <button type="button" className="btn btn-success btn-sm" onClick={() => handleAction(item, "APPROVE")}>Approve</button>
                        <button type="button" className="btn btn-danger btn-sm" onClick={() => handleAction(item, "REJECT")}>Reject</button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        {totalPages > 1 ? (
          <div className="card-footer">
            <Pagination page={page} totalPages={totalPages} onPageChange={setPage} />
          </div>
        ) : null}
      </div>
    </>
  );
};

export default PendingDepositsCard;
